export type Role = 'super_admin' | 'admin' | 'dealer_manager' | 'viewer' | 'affiliate';
export const ROLE_LABELS: Record<Role, string> = {
  super_admin: 'Суперадмин',
  admin: 'Администратор',
  dealer_manager: 'Менеджер крупье',
  viewer: 'Наблюдатель',
  affiliate: 'Аффилиат'
};

export const PERMISSIONS = {
  USERS_VIEW: 'users:view',
  USERS_EDIT: 'users:edit',
  USERS_BALANCE: 'users:balance',
  USERS_DEALER: 'users:dealer',
  USERS_DELETE: 'users:delete',
  ROOMS_VIEW: 'rooms:view',
  ROOMS_EDIT: 'rooms:edit',
  ROOMS_FORCE_END: 'rooms:force_end',
  ROOMS_PEEK: 'rooms:peek',
  RAKE_VIEW: 'rake:view',
  RAKE_WITHDRAW: 'rake:withdraw',
  AUDIT_VIEW: 'audit:view',
  SETTINGS: 'settings:edit',
  AFFILIATE_VIEW: 'affiliate:view',
  AFFILIATE_MANAGE: 'affiliate:manage'
} as const;
export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  super_admin: Object.values(PERMISSIONS).filter((p) => p !== PERMISSIONS.AFFILIATE_VIEW),
  admin: [
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_EDIT,
    PERMISSIONS.USERS_BALANCE,
    PERMISSIONS.USERS_DEALER,
    PERMISSIONS.ROOMS_VIEW,
    PERMISSIONS.ROOMS_EDIT,
    PERMISSIONS.ROOMS_FORCE_END,
    PERMISSIONS.ROOMS_PEEK,
    PERMISSIONS.RAKE_VIEW,
    PERMISSIONS.RAKE_WITHDRAW,
    PERMISSIONS.AUDIT_VIEW,
    PERMISSIONS.AFFILIATE_MANAGE
  ],
  dealer_manager: [
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_BALANCE,
    PERMISSIONS.USERS_DEALER,
    PERMISSIONS.ROOMS_VIEW,
    PERMISSIONS.ROOMS_PEEK,
    PERMISSIONS.RAKE_VIEW
  ],
  viewer: [PERMISSIONS.USERS_VIEW, PERMISSIONS.ROOMS_VIEW, PERMISSIONS.RAKE_VIEW],
  affiliate: [PERMISSIONS.AFFILIATE_VIEW]
};
